import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    bannerListLoading: false,
    bannerList: {},
    bannerListError: null,
    bannerDetailsLoading: false,
    bannerDetails: {},
    bannerDetailsError: "",
    bannerByIdLoading: false,
    bannerByIdSuccess: {},
    bannerByIdError: ""
}

export const bannerSlice = createSlice({
    name: 'banner',
    initialState,
    reducers: {
        getbannerListLoading: (state, action) => {
            state.bannerListLoading = true
        },
        getBannerListSuccess: (state, action) => {
            state.bannerListLoading = false
            state.bannerList = action.payload
        },

        getBannerListError: (state, action) => {
            state.bannerListLoading = false
            state.bannerList = {}
            state.bannerListError = action?.payload?.message
        },
        getBannerByIdLoading: (state, action) => {
            state.bannerByIdLoading = true


        },
        getBannerByIdSuccess: (state, action) => {
            state.bannerByIdLoading = false
            state.bannerByIdSuccess = action.payload.data
            state.bannerByIdError = ""

        },
        getBannerByIdError: (state, action) => {
            state.bannerByIdLoading = false
            state.bannerByIdSuccess = {}
            state.bannerByIdError = action.payload.message


        },
        resetBannerDetails: (state, action) => {
            state.bannerByIdLoading = false
            state.bannerByIdSuccess = {}
        }
    },
})

// Action creators are generated for each case reducer function
export const { getbannerListLoading,
    getBannerListSuccess,
    getBannerListError,
    getBannerByIdLoading,
    getBannerByIdSuccess,
    getBannerByIdError,
    resetBannerDetails

} = bannerSlice.actions

export default bannerSlice.reducer;